import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { deepEqual } from '../../../../common/utils/objectUtils.js';
import { FixedBroadbandAvailability } from '../../../../components/FixedBroadbandAvailability/FixedBroadbandAvailability.js';
import { clearFixedBroadbandOrderDraft } from '../../../../selfservice/common/fixedBroadbandOrderStorage.js';
import type { State } from '../../../../selfservice/common/store.js';

export const FixedBroadbandAvailabilityPath = () => {
  const addressSearchResult = useSelector((state: State) => state?.resources?.addressSearchResult, deepEqual);

  useEffect(() => {
    clearFixedBroadbandOrderDraft();
  }, []);

  return (
    <FixedBroadbandAvailability
      addressSearchResult={addressSearchResult}
      selectedAddressId={addressSearchResult?.match?.addressId}
    />
  );
};
